module.exports = __webpack_public_path__ + "img/appDown.3ce0acc8.jpg";